"use client";
import createFieldComponent from "../form-group/create-field-component.js";
import Autocomplete from "./autocomplete.js";
export const AutocompleteField = createFieldComponent(Autocomplete);
export default AutocompleteField;
//# sourceMappingURL=autocomplete-field.js.map